<template>
  <div>
    <div class="consent-education-4 common-consent-edu" v-if="currenEducationScreen && !isLearnMoreClick">
      <div class="text-center">
        <img :src="getStudyIcon(currenEducationScreen.sectionImage)" alt="" class="edu-green-check" />
      </div>
      <p
        class="verify-name m-0"
        :key="`${currenEducationScreen.sectionId}_sectionTitle`"
        v-translate:dynamic_string="{
          key: `${currenEducationScreen.sectionId}_sectionTitle`,
          val: lang,
          html: currenEducationScreen.sectionTitle
        }"
      >
        {{ currenEducationScreen.sectionTitle }}
      </p>
      <p
        class="pt-0 edu-consent-text"
        :key="`${currenEducationScreen.sectionId}_sectionSummary`"
        v-translate:dynamic_string="{
          key: `${currenEducationScreen.sectionId}_sectionSummary`,
          val: lang,
          html: currenEducationScreen.sectionSummary
        }"
      >
        {{ currenEducationScreen.sectionSummary }}
      </p>
      <div
        class="text-center verify-email-text primary-text cursor-pointer"
        v-if="haveLearnMoreHtml"
        @click="currentLearnMore()"
        :key="`${currenEducationScreen.sectionId}_sectionMoreTitle`"
        v-translate:dynamic_string="{
          key: `${currenEducationScreen.sectionId}_sectionMoreTitle`,
          val: lang,
          html: currenEducationScreen.sectionMoreTitle
        }"
      >
        {{ currenEducationScreen.sectionMoreTitle }}
      </div>
      <div class="text-center pt-16 ml-15 mr-15">
        <button class="btn btn-submit primary-bg" @click="nextItem" v-translate:text_signin_button="lang">
          Next
        </button>
      </div>
    </div>
    <div class="consent-education-4 common-consent-edu" v-if="isLearnMoreClick">
      <div v-if="currenEducationScreen">
        <div style="max-width: 100%; overflow: auto" :key="currenEducationScreen.sectionHtmlContent" v-quill-html:getParticipantStudyVideos.src="currenEducationScreen.sectionHtmlContent"></div>
        <div class="text-center pt-16 ml-15 mr-15">
          <button class="btn btn-submit primary-bg" @click="onLearDoneClick()" v-translate:rsb_done="lang">
            Done
          </button>
        </div>
      </div>

      <div v-else>
        <div class="loader"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Consent, Bitrise, Widget, ParticipantPortal } from "@/components/services/participant-service";
export default {
  name: "join-consent-education",
  components: {},
  props: ["isOnBackClick", "lang", "currentConsent", "page"],
  data() {
    return {
      widget: new Widget(),
      portal: new ParticipantPortal(),
      bitrise: new Bitrise(),
      consent: new Consent(),
      isParticipantAgreed: false,
      eConsentDetails: null,
      consentEducation: this.currentConsent.details.sections,
      currenEducationScreen: null,
      currentConObjIndex: this.page,
      isLearnMoreClick: false,
      currentConsentLearnData: ""
    };
  },
  computed: {
    ...mapGetters(["participant", "getParticipantPortalConsentData", "getParticipantStudyVideos"]),
    globalElements() {
      return this.$store.getters.getParticipantsPortalGlobalElements;
    },
    haveLearnMoreHtml() {
      return this.currenEducationScreen.sectionMoreTitle && this.bitrise.isHTMLAvailable(this.currenEducationScreen.sectionId);
    }
  },
  watch: {
    page(val) {
      this.currentConObjIndex = val;
    },
    currentConsent(val) {
      this.consentEducation = val.details.sections;
    },
    isOnBackClick(val) {
      if (val) {
        if (this.isLearnMoreClick) {
          this.onLearDoneClick();
        } else {
          this.prevItem();
        }
      }
    }
  },
  mounted() {
    this.getDetails();
    this.$root.$emit("setHeaderOptions", { hideCancel: false });  
  },
  methods: {
    nextItem() {
      if (this.currentConObjIndex == this.consentEducation.length - 1) {
        this.updateActiveScreen();
      } else {
        this.currentConObjIndex = this.currentConObjIndex + 1;
        this.currentConObjIndex = this.currentConObjIndex % this.consentEducation.length;
        this.currenEducationScreen = this.consentEducation[this.currentConObjIndex];
      }
      this.$emit("pageChange", this.currentConObjIndex);
    },
    prevItem() {
      if (this.currentConObjIndex == 0) {
        this.$emit("updateConsentScreen", "prev-consent");
      } else {
        this.currentConObjIndex = this.currentConObjIndex - 1;
        this.currentConObjIndex = this.currentConObjIndex % this.consentEducation.length;
        this.currenEducationScreen = this.consentEducation[this.currentConObjIndex];
        this.$emit("pageChange", this.currentConObjIndex);
      }
    },

    currentLearnMore() {
      this.isLearnMoreClick = true;
      const sectionTitle = this.widget.i18nActivities(`${this.currenEducationScreen.sectionId}_sectionTitle`, this.lang);
      this.$emit("updateHeaderNav", {
        showBlankHeader: true,
        backRouterLink: null,
        title: sectionTitle || this.currenEducationScreen.sectionTitle
      });
      if (this.consent && this.currenEducationScreen && this.currenEducationScreen.sectionHtmlContent) {
        this.consent.getConcentLearnMoreHtml(this.currenEducationScreen.sectionHtmlContent).then(res => {
          this.currentConsentLearnData = res;
        });
      }
      return;
    },

    getStudyIcon(key) {
      return this.bitrise.getImage(key);
    },

    agreed() {
      this.isParticipantAgreed = true;
      this.$emit("updateHeaderNav", {
        showBlankHeader: true,
        title: this.widget.translate("VERIFY_TITLE", "Verify")
      });
    },
    updateActiveScreen() {
      this.$emit("updateConsentScreen", "questions");
    },
    getDetails() {
      if (this.consent) {
        this.currenEducationScreen = this.consentEducation[this.currentConObjIndex];
      }
    },
    onLearDoneClick() {
      this.isLearnMoreClick = false;
      let i18KeyForConsentName = this.currentConsent.config.dataVantConsent ? "datavant_consent_form_title" : `${this.currentConsent.config.consentId}_consentName` ;
      let consentName = this.widget.i18nActivities(i18KeyForConsentName, this.lang);
      this.$root.$emit("setHeaderOptions", {
        title: consentName || this.currentConsent.config.consentName
      });
    }
  }
};
</script>
